import React, { useState } from 'react'
import { Modal, Form, Row, Col, Input, Button, Upload, Select } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { toast } from 'react-toastify'
import apiRequest from '../hooks/ApiRequest'

const { Option } = Select

const FinanceManagement = ({ visible, onCancel, policydetail, onSuccess, form }) => {
  const { getFieldDecorator, validateFields, resetFields } = form
  const [loading, setLoading] = useState(false)
  const [fileList, setFileList] = useState([])

  const handleSubmit = e => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (err) return
      setLoading(true)

      const formData = new FormData()
      formData.append('PolicyNumber', policydetail?.policyNumber)
      formData.append('ReceiptNumber', values.receiptNumber)
      formData.append('AmountPaid', values.amountPaid)
      formData.append('Status', values.status)
      formData.append('File', fileList[0]?.originFileObj)

      try {
        const res = await apiRequest(
          `${process.env.REACT_APP_BASE_URL}/Policy/UploadPaymentProof/upload-payment-proof`,
          'POST',
          formData
        )

        if (res.success) {
          toast.success('Payment proof uploaded successfully')
          resetFields()
          setFileList([])
          onSuccess && onSuccess()
          onCancel()
        } else {
          toast.error(res.message || 'Failed to submit payment')
        }
      } catch (err) {
        toast.error('Submission error')
      } finally {
        setLoading(false)
      }
    })
  }

  const handleUploadChange = ({ fileList }) => {
    const latestFile = fileList.slice(-1)
    setFileList(latestFile)
    form.setFieldsValue({ proofOfPayment: latestFile.length ? latestFile : null })
  }

  return (
    <Modal
      visible={visible}
      title="Upload Payment Proof"
      onCancel={onCancel}
      footer={null}
      destroyOnClose
    >
      <Form layout="vertical" onSubmit={handleSubmit}>
        <Row gutter={16}>
          <Col md={12}>
            <Form.Item label="Policy Number">
              <Input value={policydetail?.policyNumber} disabled />
            </Form.Item>
          </Col>
          <Col md={12}>
            <Form.Item label="Amount Paid">
              {getFieldDecorator('amountPaid', {
                rules: [{ required: true, message: 'Please enter amount paid' }],
              })(<Input placeholder="Enter amount paid" type="number" />)}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col md={12}>
            <Form.Item label="Receipt Number">
              {getFieldDecorator('receiptNumber', {
                rules: [{ required: true, message: 'Please enter receipt number' }],
              })(<Input placeholder="Enter receipt number" />)}
            </Form.Item>
          </Col>

          <Col md={12}>
            <Form.Item label="Payment Status">
              {getFieldDecorator('status', {
                rules: [{ required: true, message: 'Please select status' }],
              })(
                <Select placeholder="Select status">
                  <Option value="Paid">Paid</Option>
                  <Option value="Unpaid">Unpaid</Option>
                  <Option value="PartiallyPaid">Partially Paid</Option>
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item label="Proof of Payment">
              {getFieldDecorator('proofOfPayment', {
                rules: [{ required: true, message: 'Please upload proof of payment' }],
              })(
                <Upload
                  beforeUpload={() => false}
                  fileList={fileList}
                  onChange={handleUploadChange}
                >
                  <Button icon={<UploadOutlined />}>Upload File</Button>
                </Upload>
              )}
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default Form.create({ name: 'finance_modal_form' })(FinanceManagement)
